import React, { Component } from 'react';

import './Popup.scss';

interface CustomProps {
  target: string;
  cuePos: string;
  isList: boolean;
  top: number;
  left: number;
  align: string;
  right: string;
}

interface CustomState {}

class Popup extends React.Component<CustomProps, CustomState> {
  public popupElement: any;
  public cueElement: any;
  public targetElement: any;
  static defaultProps: Partial<CustomProps> = {
    cuePos: 'pos2',
    isList: true,
    top: -10,
    left: 0,
    align: 'left',
    right: '0',
  };
  constructor(props: CustomProps) {
    super(props);

    // need access to these DOM elements
    this.popupElement = null;
    this.cueElement = null;
    this.targetElement = null;

    this.toggle = this.toggle.bind(this);
  }

  componentDidMount() {
    this.targetElement = window.document.getElementById(this.props.target);
    // toggle on/off on click
    this.targetElement.addEventListener('click', this.toggle);
    // console.log('popup: ', this.popupElement);
    // console.log('cue: ', this.cueElement);
    // console.log('target: ', this.targetElement);
    this.calculatePositions();

    // toggle off the popup on render
    this.popupElement.style.display = 'none';
  }

  componentWillUnmount() {
    this.targetElement.removeEventListener('click', this.toggle);
    // console.log('clearing listener..');
  }

  toggle() {
    // console.log('toggling..');
    this.popupElement.style.display =
      this.popupElement.style.display === 'none' ? 'block' : 'none';
  }

  calculatePositions() {
    const targetDimensions = findDimensions(this.targetElement);
    const popupDimensions = findDimensions(this.popupElement);
    // console.log('top: ', this.props.top);
    // console.log('target dimension: ', targetDimensions);
    // console.log('popup dimension: ', popupDimensions);

    const leftPos =
      targetDimensions.left - popupDimensions.width - this.props.left;
    const topPos =
      targetDimensions.top + targetDimensions.height + this.props.top;

    this.popupElement.style.left = leftPos;
    this.popupElement.style.top = `${topPos + 10}px`;

    // console.log('topCalc: ', topCalc);

    // console.log('target dimension: ', targetDimensions);
    // console.log('popup dimension: ', popupDimensions);

    const { cuePos } = this.props;
    if (cuePos === 'pos1') {
      this.cueElement.style.left = '10px';
    }
    if (cuePos === 'pos2') {
      this.cueElement.style.left = `${popupDimensions.width / 2 - 5}px`;
    }
    if (cuePos === 'pos3') {
      this.cueElement.style.left = `${popupDimensions.width - 35}px`;
    }
  }

  render() {
    return (
      <div
        className={`Popup ${
          this.props.align ? `Popup--${this.props.align}` : ''
        }`}
        style={{ right: `${this.props.right ? `${this.props.right}px` : ''}` }}
        ref={(el) => {
          this.popupElement = el;
        }}
      >
        <span
          className="Popup__cue"
          ref={(cueElement) => {
            this.cueElement = cueElement;
          }}
        />
        {this.props.isList ? (
          <ul className="Popup__content">{this.props.children}</ul>
        ) : (
          <div className="Popup__content">{this.props.children}</div>
        )}
      </div>
    );
  }
}

export default Popup;

function findDimensions(obj: any) {
  const dimensions: any = {};
  dimensions.height = obj.offsetHeight;
  dimensions.width = obj.offsetWidth;
  // offsetLeft & offsetTop are relative to the nearest parent. So this does not
  // guarantee the absolute left & top values from the root(html). To calculate
  // the right dimensions starting from the root html, we traverse back to each
  // parent & keep on adding their left & top values until we reach the root parent.
  let curleft = 0;
  let curtop = 0;
  if (obj.offsetParent) {
    do {
      curleft += obj.offsetLeft;
      curtop += obj.offsetTop;
      /* eslint no-cond-assign: 0 */
      /* eslint no-param-reassign: 0 */
    } while (obj === obj.offsetParent);
  }
  dimensions.left = curleft;
  dimensions.top = curtop;
  return dimensions;
}
